import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnarchiv: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnarchiv"><Path d="M9.5 2.5L3.5 7.5V20.5H20.5V7.5L14.5 2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 11.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4 7.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUnarchiv;
